<app-modal *ngIf="deviceService.isDesktop()"
           [canClose]="false"
           (closed)="onClose()">
  <app-modal-body>
    <ng-container [ngTemplateOutlet]="contentRef"></ng-container>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="!deviceService.isDesktop()"
                  [titleVisible]="false" [withCloseButton]="true"
                  [customTitle]="'profile-form.card.title' | translate"
                  (closed)="onClose()">
  <app-mobile-modal-body>
    <div class="checkout-wizard-wrap">
      <ng-container [ngTemplateOutlet]="contentRef"></ng-container>
    </div>
  </app-mobile-modal-body>
</app-mobile-modal>

<ng-template #contentRef>
  <app-step-by-step-wizard [steps]="steps" [showSteps]="false" [showHeader]="!deviceService.isMobile()" [showFooter]="false">
    <ng-container header-details>
      <app-add-card-header-details></app-add-card-header-details>
    </ng-container>

    <ng-container content>
      <ng-container [ngSwitch]="activeView">
        <ng-container *ngSwitchCase="'payment'">
          <ng-template [ngIf]="screen === 'frame'">
            <div class="hint-title">{{'profile-form.card.hint-title' | translate}}</div>
            <div class="hint-description" [class.mobile]="deviceService.isMobile()">{{'profile-form.card.hint-description' | translate}}</div>
            <div class="processing-wrapper" *ngIf="!payment">
                <div class="processing">{{'payment-form.please-wait' | translate}}</div>
                <spinner2></spinner2>
            </div>
              <app-payment-widget-merchant-processing
                *ngIf="payment"
                [payment]="payment" [isAccountPayment]="false"
                (succeed)="onSuccess()" [merchant]="merchant"
                (failed)="onFail($event)"
              ></app-payment-widget-merchant-processing>
          </ng-template>
        </ng-container>

        <ng-template [ngIf]="screen === 'success'">
          <ng-container [ngTemplateOutlet]="successRef"></ng-container>
        </ng-template>

        <ng-template [ngIf]="screen === 'fail'">
          <ng-container [ngTemplateOutlet]="failedRef"></ng-container>
        </ng-template>
      </ng-container>
    </ng-container>
  </app-step-by-step-wizard>
</ng-template>
<ng-template #successRef>
  <div class="finish-success">
    <div class="title">{{ 'meetings.wizard.add-card-success' | translate }}</div>
    <app-icon class="icon" width="98" height="98" file="pay" icon="success"></app-icon>
  </div>
</ng-template>

<ng-template #failedRef>
  <div class="finish-fail">
    <div class="title">{{ 'meetings.wizard.pay-fail' | translate }}</div>
    <app-icon class="icon" width="98" height="98" file="pay" icon="fail"></app-icon>
    <div class="description">{{errorDescription}}</div>
  </div>
</ng-template>
